<template>
  <div class="element-box">
    <form @submit.prevent="onSearch">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div v-if="officeDropdown && officeDropdown.length">
            <SelectVue
                v-model="filters.officeId"
                :options="officeDropdown"
                :is-clear="true"
                :placeholder="$t('placeholder.office_name')"
            />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div v-if="officeEngagementTypesDropdown && officeEngagementTypesDropdown.length">
            <SelectVue
                v-model="filters.engagementType"
                :options="officeEngagementTypesDropdown"
                :is-clear="true"
                :placeholder="$t('placeholder.engagement_type')"
            />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div v-if="reportStatusDropdown && reportStatusDropdown.length">
            <SelectVue
                v-model="filters.reportStatus"
                :options="reportStatusDropdown"
                :is-clear="true"
                placeholder="Status melden"
            />
          </div>
        </div>
        <div class="col-lg-2 col-sm-12 col-12">
          <SearchButton
              type="submit"
              :label="$t('general.button.search')"
              :loading="loading"/>

<!--          <button type="submit" class="btn btn-primary custom_search_button2" :disabled="loading">-->
<!--            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>-->
<!--            <span v-if="!loading">{{ $t('general.button.search') }}</span>-->
<!--            <span v-else>{{ $t('general.button.search_in_progress') }}</span>-->
<!--          </button>-->
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  officeDropdown: {
    type: Array,
    required: true,
  },
  officeEngagementTypesDropdown: {
    type: Array,
    required: true,
  },
  reportStatusDropdown: {
    type: Array,
    required: true,
  },
});

// Emit search event
const emit = defineEmits([ 'search' ]);

// Use toRefs to maintain reactivity
const { filters }                   = toRefs(props);
const officeDropdown                = toRefs(props)[ 'officeDropdown' ];
const officeEngagementTypesDropdown = toRefs(props)[ 'officeEngagementTypesDropdown' ];
const reportStatusDropdown          = toRefs(props)[ 'reportStatusDropdown' ];

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

</script>

<style scoped>
</style>
